<template>
  <div class="app-container">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-position="top"
    >
      <el-form-item label="项目介绍详情" prop="about">
        <Editor
          class="edit-form"
          ref="myQuillEditor"
          style="width: 100%"
          v-model="ruleForm.about"
        />
      </el-form-item>
      <el-form-item v-if="roles.includes('/business/save_about')">
        <el-button type="primary" @click="submitForm('ruleForm')">
          保存
        </el-button>
        <el-button type="danger" @click="reset('ruleForm')"> 重置 </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { get_about, save_about } from "@/api/investment";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl"]),
  },
  data() {
    return {
      ruleForm: {
        about: "",
      },
      rules: {
        about: [
          { required: true, message: "请输入项目介绍详情", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // if (this.userInfo.park_id !== 0) {
    //   this.screen.park_id = this.userInfo.park_id;
    // } else {
    //   this.screen.park_id = "";
    // }
    this.getInfo();
  },
  methods: {
    // 获取信息
    getInfo() {
      var that = this;
      get_about().then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          about: res.data.about,
        };
      });
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认保存？")
            .then(() => {
              save_about(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  that.$message.success("保存成功！");
                }
              });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    reset() {
      this.ruleForm.about = "";
    },
  },
};
</script>
<style lang="scss">
.edit-form {
  .ql-container.ql-snow {
    height: 70vh !important;
  }
}
</style>
